import Checklist from './checklist'

export const AmuiChecklist = Checklist

export default Vue => Vue.component(Checklist.name, Checklist)
